export function getFullUrl(domain?: string) {
    if (!domain) return "";
    return domain.startsWith("http") ? domain : `https://www.${domain}`;
}
